/* */
import React, { useCallback, Fragment } from 'react';
import { FormFeedback } from 'reactstrap';
import Switch from 'react-switch';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { positionEnum } from 'consts/data';
import { isDefine, isReactComponent } from 'helpers';
import classNames from 'classnames';
import { useStyles } from 'providers/ThemeProvider';
import useTheme from 'hooks/useTheme';
import { cn } from 'helpers/css';

const propTypes = {
  positionLabel: PropTypes.oneOf([positionEnum.left, positionEnum.right]),
};

const SwitchBoxField = ({
  form,
  field,
  onChangeCustomize,
  classNameLabel,
  label,
  disabled = false,
  onBlur,
  subLabel,
  required,
  positionLabel = positionEnum.left,
  afterOnChange,
  styleLabel,
  disableDefaultOnChange = false,
  classNameContainer,
  ...props
}) => {
  const { colorsSystem } = useStyles();
  const { isDarkTheme } = useTheme();

  const { name = '', value } = field || {};
  const { errors = {}, touched = {}, setFieldValue } = form || {};

  const error = get(errors, name);
  const itemTouched = get(touched, name);

  const onSwitch = useCallback(
    (checked, event, id) => {
      if (!disableDefaultOnChange) {
        setFieldValue && setFieldValue(id, checked);
      }
      afterOnChange && afterOnChange(id, checked);
    },
    [value, afterOnChange, disableDefaultOnChange]
  );

  const renderLabel = useCallback(() => {
    if (label) {
      return (
        <label
          className={classNames(
            classNameLabel,
            required && 'required',
            'mb-0',
            positionLabel === positionEnum.left ? 'mr-2' : 'ml-2'
          )}
          htmlFor={name}
          dangerouslySetInnerHTML={isReactComponent(label) ? undefined : { __html: label }}
          style={styleLabel}
        >
          {isReactComponent(label) ? label : undefined}
        </label>
      );
    }

    return null;
  }, [classNameLabel, label, positionLabel, required]);

  return (
    <div className={cn('component:SwitchBoxField', classNameContainer)}>
      {positionLabel === positionEnum.left && renderLabel()}
      <Switch
        {...field}
        disabled={disabled}
        onBlurCapture={field?.onBlur || onBlur}
        onChange={onChangeCustomize || onSwitch}
        onColor={isDarkTheme ? '#abbdff' : '#69b1ff'}
        onHandleColor={colorsSystem.brandPrimary}
        handleDiameter={22}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow='0px 1px 5px rgba(0, 0, 0, 0.6)'
        activeBoxShadow='0px 0px 1px 10px rgba(0, 0, 0, 0.2)'
        height={20}
        width={40}
        checked={isDefine(props?.checked) ? props?.checked : value || props?.value}
        className='react-switch'
        id={name}
      />
      {positionLabel === positionEnum.right && renderLabel()}
      {subLabel && <p className='sub-text mb-2'>{subLabel}</p>}
      {itemTouched && !!error && <FormFeedback>{error}</FormFeedback>}
    </div>
  );
};

SwitchBoxField.propTypes = propTypes;
export default SwitchBoxField;
